export const downloadAssetFile = async (assetUrl: string) => {
  const response = await fetch(assetUrl);

  if (!response.ok) {
    throw new Error('Unable to download file');
  }

  const blobData = await response.blob();
  const fileName = assetUrl.slice(assetUrl.lastIndexOf('/'));
  const metadata = {
    type: 'image'
  };

  return new File([ blobData ], fileName, metadata);
};
